import React from 'react';
import AppointmentDetails from '../components/visits/AppointmentDetails/AppointmentDetails';

const AppointmentDetailsPage = () => {

    return (
        <div className="outletConainer">
            <AppointmentDetails />
        </div>
    );
};

export default AppointmentDetailsPage;
